/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import ConversionFlowWrapper from './components/ConversionFlowWrapper';

/* utilities */
import { parseDataToProps } from 'js/utilities';

const conversionFlowWrapperNodes = Array.from(document.querySelectorAll('.conversion-flow'));
[...conversionFlowWrapperNodes].forEach((node) => render(<ConversionFlowWrapper {...parseDataToProps(node.dataset)} />, node));
